import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500">为什么数百万吃瓜群众选择我们</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6">
          {featuresData.map((feature) => (
            <div key={feature.id} className="bg-background-100 rounded-xl p-5 md:p-6 text-center border border-background-200">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${feature.icon} text-xl text-accent-600`} />
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}